import React from 'react';
import { calculateStepState, calculateProgressWidths } from './helpers';
import styled from 'styled-components';
import { theme } from '../theme';
import { Box } from '../Box';
import { StepItem } from './components/StepItem';
export const ProgressIndicator = ({ handleStepChange, onStepClick, simpleStep = false, steps, currentStep, }) => {
    const visibleSteps = steps.filter((step) => !step.isHidden);
    const currentStepIndex = visibleSteps.findIndex((step) => step.id === currentStep);
    const { totalWidth, stepWidth } = calculateProgressWidths(visibleSteps.length, simpleStep);
    const lastCompletedStepIndex = visibleSteps.findLastIndex((step) => calculateStepState(visibleSteps.indexOf(step), currentStepIndex) ===
        'completed');
    const handleStepClick = (currentStepIndex, currentStepState, stepData) => {
        if (onStepClick) {
            onStepClick({ currentStepIndex, currentStepState });
        }
        if (currentStepState !== 'disabled') {
            handleStepChange(stepData);
        }
    };
    return (React.createElement(Wrapper, { width: `${totalWidth}px`, flex: true, justifyContent: "flex-start", alignItems: "center" },
        React.createElement(DefaultProgress, { "$simpleStep": simpleStep }),
        React.createElement(Box, { flex: true }, visibleSteps.map((step, index) => {
            const stepState = calculateStepState(index, currentStepIndex);
            return (React.createElement(StepItem, { key: step.id, isCompleted: stepState === 'completed', isCurrentStep: stepState === 'current', isDisabled: stepState === 'disabled', isLastCompleted: lastCompletedStepIndex === index, onClick: () => handleStepClick(index, stepState, step), stepWidth: `${stepWidth}px`, label: step.label, isSimple: simpleStep, isLastItem: index === visibleSteps.length - 1 }));
        }))));
};
const Wrapper = styled(Box) `
  position: relative;
`;
const DefaultProgress = styled(Box) `
  z-index: 0;
  content: '';
  position: absolute;
  background: ${theme.colors.matcha};
  width: 100%;
  height: 12px;

  ${({ $simpleStep }) => $simpleStep && `border-radius:100px;`}
`;
//# sourceMappingURL=ProgressIndicator.js.map